module.exports = __webpack_public_path__ + "img/194.fe81c3d2.svg";